module.exports = __webpack_public_path__ + "c1cbb8d7173c4a0cf8d0c300ff73b73c.jpg";